import React from "react";

export default function FloorPlanGridView({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 p-2 gap-4">
      {children}
    </div>
  );
}
